import { fetchLoginData } from '../api/index.js'

const state = {
    userInfo: {}
}

const actions = {
    fetchLoginData({ commit }) {
        return fetchLoginData().then(item => {
            commit('setUserInfo', { data: item.data })
        })
    },
    jnosLogin({ commit }, data) {
        commit('setUserInfo', data);
    }
}

const mutations = {
    setUserInfo(state, { data }) {
        state.userInfo = data;
    },
}

export default {
    state,
    actions,
    mutations
}